<template>
  <div class="main">
    <el-dialog
      :close-on-click-modal="false"
      :title="openData.title"
      :visible.sync="openData.state"
      width="1000px"
      class="dialog_container"
      @close="dialogVisibleClose"
    >
      <div class="dialog_content">
        <div class="fromMain">
          <el-button
            @click="changeButtonType('基本信息')"
            :type="formButtonType === '基本信息' ? 'primary' : 'info'"
            >基本信息
          </el-button>
          <el-button
            @click="changeButtonType('设备信息')"
            :type="formButtonType === '设备信息' ? 'primary' : 'info'"
            >设备信息
          </el-button>
        </div>
        <div v-show="formButtonType === '基本信息'">
          <el-form
            :disabled="openData.title == '查看' || openData.title == '审核'"
            label-width="100px"
            :model="addForm"
            ref="addForm"
            :rules="addFormRules"
          >
            <el-row>
              <el-col :span="15">
                <el-form-item label="服务点名称:" prop="servicePointName">
                  <el-input
                    v-model.trim="addForm.servicePointName"
                    placeholder="请输入服务点名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="服务类型:" prop="servicePointType">
                  <el-select
                    style="width: 100%"
                    v-model="addForm.servicePointType"
                    clearable
                    placeholder="请选择服务类型"
                  >
                    <el-option
                      v-for="item in serveList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="服务点热线:" prop="servicePhone">
                  <el-input
                    v-model.trim="addForm.servicePhone"
                    placeholder="请输入服务点热线"
                  ></el-input>
                </el-form-item>
                <el-form-item label="医疗床位数:" prop="medicalBeds">
                  <el-input
                    v-model.number="addForm.medicalBeds"
                    placeholder="请输入医疗床位数"
                  ></el-input>
                </el-form-item>
                <el-form-item label="运营模式:" prop="operatingModel">
                  <el-select
                    style="width: 100%"
                    v-model="addForm.operatingModel"
                    clearable
                    placeholder="请选择运营模式"
                  >
                    <el-option
                      v-for="item in operateList"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8" :offset="1">
                <el-form-item label-width="0" prop="photo">
                  <el-upload
                    style="width: 100%"
                    :action="baseUrl"
                    class="el-upload1"
                    :show-file-list="false"
                    :on-success="
                      (file, fileList) => {
                        handleAvatarSuccess(file, fileList, 'add')
                      }
                    "
                    :before-upload="beforeAvatarUpload"
                  >
                    <div>
                      <i
                        class="el-icon-plus avatar_uploader avatar-uploader-icon"
                        v-if="addForm.photo == '' && openData.title == '新增'"
                      ></i>
                      <div class="avatar" v-else>
                        <img alt v-if="addForm.photo" :src="addForm.photo" />
                      </div>
                    </div>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-row>
            <div style="display: flex; justify-content: space-between">
              <el-form-item
                label="服务点性质:"
                prop="servicePointNature"
                style="width: 50%"
              >
                <el-select
                  style="width: 100%"
                  v-model="addForm.servicePointNature"
                  clearable
                  placeholder="请选择服务点性质"
                >
                  <el-option
                    v-for="item in servePoint"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="服务点规模:"
                prop="servicePointScale"
                style="width: 50%"
              >
                <el-select
                  style="width: 100%"
                  v-model="addForm.servicePointScale"
                  clearable
                  placeholder="请选择服务点规模"
                >
                  <el-option
                    v-for="item in serviceTypeList"
                    :key="item.id"
                    :label="item.dictName"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <el-form-item label="服务点地址：">
              <el-row>
                <el-col :span="4">
                  <el-form-item>
                    <el-select
                      v-model="addForm.shengId"
                      placeholder="请选择省"
                      @change="handleProvince"
                      :disabled="
                        normalInfo.orgLevel == 1 ||
                        normalInfo.orgLevel == 2 ||
                        normalInfo.orgLevel == 3 ||
                        normalInfo.orgLevel == 4 ||
                        normalInfo.orgLevel == 5 ||
                        openData.title == '审核' ||
                        openData.title == '查看'
                      "
                      style="width: 100%"
                      ref="selectShengChange"
                    >
                      <el-option
                        v-for="(item, index) in provinceList"
                        :key="index"
                        :label="item.name"
                        :value="item.adcode"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="addForm.shiId"
                    placeholder="请选择市"
                    @change="handleCity"
                    :disabled="
                      normalInfo.orgLevel == 2 ||
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '审核' ||
                      openData.title == '查看'
                    "
                    ref="selectShiChange"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in cityList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="addForm.quId"
                    :disabled="
                      normalInfo.orgLevel == 3 ||
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '审核' ||
                      openData.title == '查看'
                    "
                    placeholder="请选择区"
                    @change="handleArea"
                    ref="selectQuChange"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="(item, index) in areaList"
                      :key="index"
                      :label="item.name"
                      :value="item.adcode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="addForm.jiedaoId"
                    :disabled="
                      normalInfo.orgLevel == 4 ||
                      normalInfo.orgLevel == 5 ||
                      openData.title == '审核' ||
                      openData.title == '查看'
                    "
                    placeholder="请选择街道"
                    @change="streetChange"
                    ref="selectJiedaoChange"
                  >
                    <el-option
                      v-for="(item, index) in streetList"
                      :key="index"
                      :label="item.addName"
                      :value="item.addCode"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :span="4" :offset="1">
                  <el-select
                    v-model="addForm.shequId"
                    :disabled="
                      normalInfo.orgLevel == 5 ||
                      openData.title == '审核' ||
                      openData.title == '查看'
                    "
                    placeholder="请选择社区"
                    ref="selectShequChange"
                    @change="handleCommunityChange"
                  >
                    <el-option
                      v-for="item in communityList"
                      :key="item.id"
                      :label="item.address"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
              <el-form-item prop="address">
                <input
                  style="margin: 15px 0"
                  v-model.trim="addForm.address"
                  :disabled="
                    openData.title == '审核' || openData.title == '查看'
                  "
                  id="tipinput"
                  class="el-input__inner"
                  :class="
                    openData.title == '审核' || openData.title == '查看'
                      ? 'innerCur'
                      : ''
                  "
                  @focus="getMap('tipinput')"
                  placeholder="请输入关键字"
                  autocomplete="off"
                />
              </el-form-item>
              <div class="map_container">
                <div
                  class="map_right"
                  id="container"
                  style="width: 100%; height: 300px"
                ></div>
              </div>
            </el-form-item>
          </el-form>
          <el-form
            label-width="100px"
            :model="exmainData"
            ref="exmains"
            :rules="exmainDataRules"
            v-if="
              openData.title == '审核' ||
              exmainData.reviewStatus == '1' ||
              exmainData.reviewStatus == '2'
            "
          >
            <el-form-item label="审核结果：" prop="reviewStatus">
              <el-radio-group v-model="exmainData.reviewStatus">
                <el-radio label="1">审核通过</el-radio>
                <el-radio label="2">审核不通过</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="审核意见：" prop="auditOpinion">
              <el-input
                type="textarea"
                :autosize="{ minRows: 2 }"
                v-model="exmainData.auditOpinion"
                placeholder="请输入审核意见"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div v-show="formButtonType === '设备信息'" style="margin-bottom: 10px">
          <el-button
            type="success"
            style="border-radius: 5px"
            icon="iconfont icon-xinzeng"
            v-if="openData.title == '新增'"
            @click="showCertificateDialog('新增', 'add')"
            >新增
          </el-button>
          <el-table
            :data="
              certificateData.slice(
                (certificate.pageNo - 1) * certificate.pageSize,
                certificate.pageNo * certificate.pageSize
              )
            "
            tooltip-effect="dark"
            style="width: 100%; margin: 15px 0"
            border
          >
            <el-table-column
              type="index"
              width="70"
              label="序号"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="equipmentNumber"
              label="设备编号"
              align="center"
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              prop="equipmentName"
              label="设备名称"
              align="center"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="设备位置"
              align="center"
              prop="equipmentPosition0"
              :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
              label="操作"
              align="center"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span
                  @click="showCertificateDialog('查看', scope.row)"
                  style="margin-right: 12px; cursor: pointer"
                  >查看</span
                >
                <span
                  v-if="openData.title == '新增'"
                  @click="deleteCertificate(index)"
                  style="margin-right: 12px; cursor: pointer"
                  >删除</span
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :page-sizes="[10, 20, 50, 100]"
            :page-size="certificate.pageSize"
            :current-page.sync="certificate.pageNo"
            layout="total, sizes, prev, pager, next, jumper"
            :total="certificateData.length"
            @size-change="handletableDataSize"
            @current-change="handleTableDataChange"
          ></el-pagination>
        </div>
        <div
          v-if="openData.title != '查看'"
          style="
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 15px;
          "
        >
          <el-button type="primary" @click="save">确 定</el-button>
          <el-button @click="dialogVisibleClose">取 消</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 证书弹框-->

    <el-dialog
      :close-on-click-modal="false"
      :title="certificateTitle"
      :visible.sync="certificateVisible"
      width="700px"
      @close="certificateDialogClose"
    >
      <el-form
        ref="certificate"
        :model="certificateForm"
        :rules="certificateFormRules"
        label-width="90px"
        :disabled="certificateTitle === '查看'"
      >
        <el-form-item label="设备名称:" prop="equipmentId">
          <el-select
            v-model="certificateForm.equipmentId"
            placeholder="请选择设备"
            @change="handleCertificate"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in certificateList"
              :key="index"
              :label="item.equipmentName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="设备编号:" prop="equipmentNumber">
          <el-input
            disabled
            v-model.number="certificateForm.equipmentNumber"
            placeholder="请输入"
            style="width: 100%"
          ></el-input>
        </el-form-item>

        <el-form-item label="设备位置:" prop="equipmentPosition">
          <el-select
            @change="handlePosition"
            v-model="certificateForm.equipmentPosition"
            placeholder="请选择位置"
            style="width: 100%"
          >
            <el-option
              v-for="(item, index) in certificateAddress"
              :key="index"
              :label="item.dictName"
              :value="item.id"
            >
            </el-option>
          </el-select>
          <!-- <el-input
                        v-model="certificateForm.equipmentPosition"
                        placeholder="请输入"
                        style="width: 100%"
                    ></el-input> -->
        </el-form-item>
        <el-form-item label="设备信息:" prop="equipmentInfo">
          <el-input
            v-model="certificateForm.equipmentInfo"
            type="textarea"
            :autosize="{ minRows: 2 }"
            placeholder="请输入"
            style="width: 100%"
          ></el-input>
        </el-form-item>
        <el-form-item label="上传图片:" prop="photo">
          <div class="avatar-uploader2">
            <el-upload
              :action="baseUrl"
              class="el-upload2"
              :show-file-list="false"
              :on-success="handleAvatarSuccess2"
              :before-upload="beforeAvatarUpload"
            >
              <img
                alt
                v-if="certificateForm.photo"
                :src="certificateForm.photo"
                style="width: 178px; height: 178px"
                class="avatar2"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon2"></i>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
      <div
        v-if="certificateTitle != '查看'"
        style="
          display: flex;
          justify-content: center;
          align-items: center;
          margin-top: 15px;
        "
      >
        <el-button type="primary" @click="certificateSend">确 定</el-button>
        <el-button @click="certificateDialogClose">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import baseURL from "@/api/baseURL"
export default {
  props: ["openData"],
  data() {
    var chekPhone = (rule, value, callback) => {
      let validatePhone = /^1[3|4|5|6|7|8|9]\d{9}$/
      if (!validatePhone.test(value)) {
        return callback(new Error("手机号格式错误"))
      }
      callback()
    }
    return {
      normalInfo: {},
      certificateList: [],
      certificateAddress: [],
      exmainData: {
        reviewStatus: "",
        auditOpinion: "",
      },
      exmainDataRules: {
        reviewStatus: [
          {
            required: true,
            message: "请选择审批结果",
            trigger: "blur",
          },
        ],
      },
      serveList: [
        { label: "街道养老服务中心", value: "0" },
        { label: "社区养老机构", value: "1" },
        { label: "小区养老服务点", value: "2" },
      ],
      operateList: [
        { label: "公办公营", value: "0" },
        { label: "公办民营", value: "1" },
        { label: "民办民营", value: "2" },
      ],
      servePoint: [
        { label: "盈利", value: "0" },
        { label: "非盈利", value: "1" },
      ],
      serviceTypeList: [],

      // 图片上传地址
      baseUrl: baseURL + "/ypt/controller/uploadController/info/uploadPhoto",
      addForm: {
        communityId: "",
        servicePointName: "",
        servicePointType: "",
        servicePhone: "",
        medicalBeds: "",
        operatingModel: "",
        photo: "",
        servicePointNature: "",
        servicePointScale: "",
        shengId: "", //省
        shiId: "", //市
        quId: "", //区
        jiedaoId: "", //街道
        shequId: "", //社区
        address: "",
        longitude: "",
        latitude: "",
      },
      provinceList: [], //省列表
      cityList: [], //市列表
      areaList: [], //区列表
      streetList: [], //街道列表
      communityList: [], //社区列表
      myMap: null,
      isMap: true,
      polygons: [],
      polygon: [],
      marker: null, //地图标记点
      recMap: null,
      recIsMap: true,
      recPolygons: [],
      recPolygon: [],
      recMarker: null, //地图标记点
      addFormRules: {
        servicePointName: [
          {
            required: true,
            message: "请输入服务点名称",
            trigger: "blur",
          },
        ],
        servicePhone: [
          {
            required: true,
            message: "请输入服务热线",
            trigger: "blur",
          },
          { validator: chekPhone, trigger: "blur" },
        ],
        medicalBeds: [
          {
            required: true,
            message: "请输入医疗床位数量",
            trigger: "blur",
          },
        ],
        servicePointType: [
          {
            required: true,
            message: "请选择服务类型",
            trigger: "blur",
          },
        ],
        operatingModel: [
          {
            required: true,
            message: "请选择运营模式",
            trigger: "blur",
          },
        ],
        servicePointNature: [
          {
            required: true,
            message: "请选择服务点性质",
            trigger: "blur",
          },
        ],
        servicePointScale: [
          {
            required: true,
            message: "请选择服务点规模",
            trigger: "blur",
          },
        ],
        // photo: [
        //     {
        //         required: true,
        //         message: "请上传图片",
        //         trigger: "blur",
        //     },
        // ],
      },
      formButtonType: "基本信息",
      type: 0,
      certificateData: [], //设备名称列表
      certificate: { pageNo: 1, pageSize: 10, total: 0 },
      certificateTitle: "",
      certificateVisible: false,
      certificateForm: {
        equipmentId: 0,
        equipmentNumber: "",
        equipmentInfo: "",
        equipmentPosition: "",
        photo: "",
      },
      certificateFormRules: {
        equipmentId: [
          {
            required: true,
            message: "设备名称不能为空",
            trigger: "blur",
          },
        ],
        equipmentNumber: [
          {
            required: true,
            message: "设备编号不能为空",
            trigger: "blur",
          },
        ],
        equipmentInfo: [
          {
            required: true,
            message: "设备信息不能为空",
            trigger: "blur",
          },
        ],
        equipmentPosition: [
          {
            required: true,
            message: "设备位置不能为空",
            trigger: "blur",
          },
        ],
        // photo: [
        //     {
        //         required: true,
        //         message: "图片不能为空",
        //         trigger: "blur",
        //     },
        // ],
      },
      auditFlag: undefined,
      failureReason: undefined,
      // 设备名称列表
      certificateNameList: [],
      // 设备编号列表
      certificateTypeList: [],
      // 文化程度列表 学历 小学_0 初中_1 高中_2 职校_3 专科_4 本科_5 研究生_6 博士_7 其他_8
      personStudyList: [
        { label: "小学", value: "0" },
        { label: "初中", value: "1" },
        { label: "高中", value: "2" },
        { label: "职校", value: "3" },
        { label: "专科", value: "4" },
        { label: "本科", value: "5" },
        { label: "研究生", value: "6" },
        { label: "博士", value: "7" },
        { label: "其他", value: "8" },
      ],
    }
  },
  created() {
    this.addForm = {
      communityId: "",
      servicePointName: "",
      servicePointType: "",
      servicePhone: "",
      medicalBeds: "",
      operatingModel: "",
      photo: "",
      servicePointNature: "",
      servicePointScale: "",
      shengId: "", //省
      shiId: "", //市
      quId: "", //区
      jiedaoId: "", //街道
      shequId: "", //社区
      address: "",
      longitude: "",
      latitude: "",
    }
    setTimeout(async () => {
      await this.$nextTick(() => this.loadmap())
    }, 200)
    this.getFindList()

    this.getOrg()
  },
  methods: {
    //获取组织机构
    getOrg() {
      this.$http
        .request({
          url: "/rbac/admin/org/info/findOrgById",
          method: "POST",
          data: { id: this.$store.state.info.orgId },
        })
        .then((res) => {
          if (res.code == 200) {
            // this.getProvince()
            this.normalInfo = res.content
            if (this.openData.title == "新增") {
              this.changeFirst()
            }
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //街道地址列表
    getStreetList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/addressYpe/info/findList",
            method: "POST",
            data: {
              parentId: val,
              pageNo: 1,
              pageSize: -1,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              this.streetList = res.content.list
              resolve(res.content.list)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 社区地址列表
    getCommityList(val) {
      let self = this
      return new Promise((resolve, reject) => {
        self.$http
          .request({
            url: "/ypt/admin/standardAddress/info/StandardAddressTree",
            method: "POST",
            data: {
              jiedaoId: val,
            },
          })
          .then((res) => {
            if (res.code == 200) {
              if (!res.content) {
                resolve([])
                return
              }
              resolve(res.content)
            } else {
              resolve([])
            }
          })
      }).catch((err) => {
        console.log(err)
      })
    },
    //获取地址
    getDistricts(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    async changeFirst() {
      console.log(
        this.normalInfo,
        "机构信息 normalInfo.orgLevel",
        this.provinceList
      )
      let province = await this.getDistricts()
      this.provinceList = province.districtList
      if (this.normalInfo.provinceId == 0) {
        this.normalInfo.provinceId = ""
      } else {
        this.normalInfo.provinceId = String(this.normalInfo.provinceId)
        let cityList = await this.getDistricts(this.normalInfo.provinceId)
        this.cityList = cityList.districtList
        console.log("城市", this.cityList)
      }
      if (this.normalInfo.cityId) {
        this.normalInfo.cityId = String(this.normalInfo.cityId)
        let areaList = await this.getDistricts(this.normalInfo.cityId)
        this.areaList = areaList.districtList
      } else {
        this.normalInfo.cityId = ""
      }

      if (this.normalInfo.areaId) {
        this.normalInfo.areaId = String(this.normalInfo.areaId)
        let streetList = await this.getStreetList(this.normalInfo.areaId)
        this.streetList = streetList
      } else {
        this.normalInfo.areaId = ""
      }
      if (this.normalInfo.streetId) {
        this.normalInfo.streetId = String(this.normalInfo.streetId)
        let communityList = await this.getCommityList(this.normalInfo.streetId)
        this.communityList = communityList
      } else {
        this.normalInfo.streetId = ""
      }
      if (this.normalInfo.orgLevel == 1 || this.normalInfo.orgLevel == 0) {
        this.provinceList.forEach((item) => {
          if (item.adcode == this.normalInfo.provinceId) {
            this.addForm.latitude = item.center.lat
            this.addForm.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 2) {
        this.cityList.forEach((item) => {
          if (item.adcode == this.normalInfo.cityId) {
            this.addForm.latitude = item.center.lat
            this.addForm.longitude = item.center.lng
          }
        })
      } else if (this.normalInfo.orgLevel == 3) {
        this.areaList.forEach((item) => {
          if (item.adcode == this.normalInfo.areaId) {
            this.addForm.latitude = item.center.lat
            this.addForm.longitude = item.center.lng
          }
        })
      } else if (
        this.normalInfo.orgLevel == 4 ||
        this.normalInfo.orgLevel == 5
      ) {
        this.streetList.forEach((item, index) => {
          if (item.addCode == this.normalInfo.streetId) {
            this.addForm.latitude = item.latitude
            this.addForm.longitude = item.longitude
          }
        })
      }

      if (this.normalInfo.communityId) {
        this.normalInfo.communityId = String(this.normalInfo.communityId)
      } else {
        this.normalInfo.communityId = ""
      }
      this.addForm.shengId = this.normalInfo.provinceId
      this.addForm.shiId = this.normalInfo.cityId
      this.addForm.quId = this.normalInfo.areaId
      this.addForm.jiedaoId = this.normalInfo.streetId
      this.addForm.shequId = this.normalInfo.communityId
      this.potintMap()
      this.$forceUpdate()
      // console.log(this.normalInfo, "机构信息",this.)
    },
    //打点
    potintMap() {
      const self = this
      try {
        self.myMap.remove(self.marker)
      } catch (err) {
        console.log(err)
      }
      console.log(
        Number(this.addForm.longitude),
        Number(this.addForm.latitude),
        "坐标"
      )
      self.marker = new AMap.Marker({
        icon: "http://webapi.amap.com/theme/v1.3/markers/n/mark_b.png",
        position: [
          Number(this.addForm.longitude),
          Number(this.addForm.latitude),
        ],
      })
      self.myMap.add(self.marker)
      self.myMap.setFitView()
    },
    getMap(input) {
      const self = this
      const autoOptions = {
        city: self.addForm.quId,
        citylimit: true,
        input: input,
      }
      // alert(input)
      const auto = new AMap.Autocomplete(autoOptions)
      //构造地点查询类
      AMap.event.addListener(auto, "select", (e) => {
        self.addForm.address = e.poi.name
        self.addForm.longitude = e.poi.location.lng
        self.addForm.latitude = e.poi.location.lat
        console.log(e.poi.location, "地址")
        self.potintMap()
      })
    },
    // 设备分页
    handletableDataSize(val) {
      this.certificate.pageSize = val
    },
    handleTableDataChange(val) {
      this.certificate.pageNo = val
    },

    //获取服务规模
    getFindList() {
      this.$http
        .request({
          url: "/rbac/admin/dict/info/list",
          method: "POST",
          data: {
            pageSize: 10,
            pageNo: 1,
            typeId: "servicePointScale",
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.serviceTypeList = []
              return
            }
            this.serviceTypeList = res.content.list
            this.addForm.communityId = this.openData.communityId
            this.getProvince()
            if (this.openData.title != "新增") {
              this.getData()
            }
          }
        })
    },
    // 加入地址图片
    joinAddress(address = "") {
      let self = this
      self.$nextTick(() => {
        let shengName = this.$refs.selectShengChange.selectedLabel
        let shiName = this.$refs.selectShiChange.selectedLabel
        let quName = this.$refs.selectQuChange.selectedLabel
        let jiedaoName = this.$refs.selectJiedaoChange.selectedLabel
        let shequName = this.$refs.selectShequChange.selectedLabel
        console.log(
          shengName + shiName + quName + jiedaoName + shequName,
          "111"
        )
        if (!address) {
          self.addForm.address =
            shengName + shiName + quName + jiedaoName + shequName
        }
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }
        let geocoder = new AMap.Geocoder({ city: "" })
        self.marker = new AMap.Marker()
        geocoder.getLocation(this.addForm.address, function (status, result) {
          if (status === "complete" && result.geocodes.length) {
            let lnglat = result.geocodes[0].location
            self.addForm.longitude = lnglat.lng
            self.addForm.latitude = lnglat.lat
            self.marker.setPosition(lnglat)
            self.myMap.add(self.marker)
            self.myMap.setFitView(self.marker)
          } else {
            log.error("根据地址查询位置失败")
          }
        })
      })
    },
    //获取省级
    async getProvince() {
      this.provinceList = []
      this.cityList = []
      this.areaList = []
      this.streetList = []
      let province = await this.getDistrict()
      this.provinceList = province.districtList
    },
    //  省级地址选择发生改变
    async handleProvince(val) {
      this.cityList = []
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.shiId = ""
      this.addForm.quId = ""
      this.addForm.jiedaoId = ""
      this.addForm.shequId = ""
      this.addForm.address = ""
      let city = await this.getDistrict(val)
      this.cityList = city.districtList
      this.joinAddress()
    },
    //市级地址发生改变
    async handleCity(val) {
      this.areaList = []
      this.streetList = []
      this.communityList = []
      this.addForm.quId = ""
      this.addForm.jiedaoId = ""
      this.addForm.shequId = ""
      this.addForm.address = ""
      let area = await this.getDistrict(val)
      this.areaList = area.districtList
      this.joinAddress()
    },
    //县区级地址发生改变
    async handleArea(val) {
      this.streetList = []
      this.communityList = []
      this.addForm.jiedaoId = ""
      this.addForm.shequId = ""
      this.addForm.address = ""
      // val = val.replace(/.$/, "");
      let street = await this.getStreetList(val)
      this.streetList = street
      this.joinAddress()
    },

    //街道地址发生变化
    async streetChange(val) {
      this.addForm.shequId = ""
      let communityList = await this.getCommityList(val)
      console.log(communityList, "社区列表")
      this.communityList = communityList
      this.joinAddress()
    },
    handleCommunityChange(val) {
      this.$nextTick(() => {
        this.$forceUpdate()
        this.joinAddress()
      })
    },

    //加载地图
    loadmap() {
      let self = this
      return new Promise((resolve, reject) => {
        self.myMap = new AMap.Map("container", {
          resizeEnable: true,
          zoom: 18,
        })
        resolve()
      })
    },
    //获取数据
    getData() {
      const self = this
      let params = {
        id: this.openData.id,
      }
      self.$http
        .request({
          url: "/ypt/admin/pensionServicePoint/info/get",
          method: "POST",
          data: params,
        })
        .then(async (res) => {
          if (res.code == 200) {
            this.getCertificate()
            this.findCertificate()
            let jsonTemp = { ...res.content }
            self.exmainData.auditOpinion = jsonTemp.auditOpinion
            self.exmainData.reviewStatus = jsonTemp.reviewStatus
            self.addForm.id = jsonTemp.id
            self.addForm.servicePointName = jsonTemp.servicePointName
            self.addForm.servicePointType = jsonTemp.servicePointType
            self.addForm.servicePhone = jsonTemp.servicePhone
            self.addForm.medicalBeds = jsonTemp.medicalBeds
            self.addForm.operatingModel = jsonTemp.operatingModel
            self.addForm.photo = jsonTemp.photo
            self.addForm.address = jsonTemp.address
            self.addForm.servicePointNature = jsonTemp.servicePointNature
            self.addForm.servicePointScale = Number(jsonTemp.servicePointScale)

            self.certificateData = jsonTemp.equipments
              ? jsonTemp.equipments
              : []
            self.addForm.shengId = jsonTemp.shengId
              ? String(jsonTemp.shengId)
              : ""
            self.addForm.shiId = jsonTemp.shiId ? String(jsonTemp.shiId) : ""
            self.addForm.quId = jsonTemp.quId ? String(jsonTemp.quId) : ""
            self.addForm.jiedaoId = jsonTemp.jiedaoId
              ? String(jsonTemp.jiedaoId)
              : ""
            self.addForm.shequId = jsonTemp.shequId
              ? Number(jsonTemp.shequId)
              : ""
            if (!self.addForm.shengId) return
            let city = await self.getDistrict(self.addForm.shengId)
            self.cityList = city.districtList
            if (!self.addForm.shiId) return
            let area = await self.getDistrict(self.addForm.shiId)
            self.areaList = area.districtList
            if (!self.addForm.quId) return
            let street = await self.getStreetList(self.addForm.quId)
            self.streetList = street
            if (!self.addForm.jiedaoId) return
            // self.streetChange(self.addForm.jiedaoId, true)
            let communityList = await self.getCommityList(self.addForm.jiedaoId)
            self.communityList = communityList
          } else {
            this.$message.error(res.message)
          }
        })
    },
    //获取地址
    getDistrict(name = "中国", params = null) {
      let self = this
      return new Promise((resolve, reject) => {
        var opts = {
          subdistrict: 1, //返回下一级行政区
          extensions: "all",
          showbiz: false, //最后一级返回街道信息
        }
        let district = new AMap.DistrictSearch(opts)
        let geocoder = new AMap.Geocoder({
          city: "", //城市设为北京，默认：“全国”
          radius: 1000, //范围，默认：500
        })
        try {
          self.myMap.remove(self.marker)
        } catch (err) {
          console.log(err)
        }

        self.marker = new AMap.Marker()
        district.search(name, (status, result) => {
          if (status == "complete") {
            resolve(result.districtList[0])
            if (this.isMap) {
              this.isMap = false
              return
            }
            let bounds = result.districtList[0].boundaries
            self.polygon = null
            if (bounds) {
              try {
                self.myMap.remove(self.polygons)
              } catch (error) {
                console.log("移除地图编辑出错了")
              }
              self.polygons = []
              for (let i = 0, l = bounds.length; i < l; i++) {
                self.polygon = new AMap.Polygon({
                  map: self.myMap,
                  strokeWeight: 1,
                  strokeColor: "#0091ea",
                  fillColor: "#80d8ff",
                  fillOpacity: 0.4,
                  path: bounds[i],
                })
                self.polygons.push(self.polygon)
                if (!params) {
                  self.polygon.on("click", function (e) {
                    let lnglat = e.lnglat
                    self.myMap.add(self.marker)
                    self.marker.setPosition(lnglat)
                    geocoder.getAddress(lnglat, function (status, result) {
                      if (status === "complete" && result.regeocode) {
                        var address = result.regeocode.formattedAddress
                        self.addForm.address = address
                        self.addForm.longitude = lnglat.lng
                        self.addForm.latitude = lnglat.lat
                      } else {
                        console.error("根据经纬度查询地址失败")
                      }
                    })
                  })
                  self.myMap.add(self.polygons)
                  self.myMap.setFitView() //地图自适应
                } else {
                  if (params.longitude && params.latitude) {
                    self.myMap.add(self.marker)
                    self.marker.setPosition([params.longitude, params.latitude])
                    self.myMap.setFitView(self.marker)
                    self.myMap.setZoom(11)
                  }
                }
              }
            }
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 新增设备信息上传图片
    handleAvatarSuccess2(res, file) {
      this.$set(this.certificateForm, "photo", res.content)
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png"
      const isLt2M = file.size / 1024 / 1024 < 5
      // if (!isJPG) {
      //   this.$message.error('上传头像图片只能是 JPG 格式!');
      //   return isJPG
      // }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 5MB!")
        return isLt2M
      }
    },
    // 关闭证书弹框
    certificateDialogClose() {
      this.certificateVisible = false
      this.certificateForm = {
        equipmentId: 0,
        equipmentNumber: "",
        equipmentInfo: "",
        equipmentPosition: "",
        photo: "",
      }
    },
    // 证书弹框发送
    certificateSend() {
      this.$refs["certificate"].validate((valid) => {
        if (valid) {
          this.certificateData.push(this.certificateForm)
          this.certificateVisible = false
        }
      })
    },
    // 显示证书弹框
    showCertificateDialog(title, row) {
      console.log(row, "45")
      console.log(row.equipmentPosition, "44")
      if (this.certificateAddress.length == 0) {
        this.getCertificate()
        this.findCertificate()
      }
      // if (title == "新增") {
      //     this.changeFirst()
      // }
      this.certificateTitle = title
      this.certificateVisible = true
      this.certificateForm = {
        equipmentId: title == "新增" ? null : Number(row.equipmentId),
        equipmentNumber: title == "新增" ? "" : row.equipmentNumber,
        equipmentInfo: title == "新增" ? "" : row.equipmentInfo,
        equipmentPosition:
          title == "新增" ? null : Number(row.equipmentPosition),
        photo: title == "新增" ? "" : row.photo,
      }
    },
    //获取设备位置
    findCertificate() {
      this.$http
        .request({
          url: "/rbac/admin/dict/info/list",
          method: "POST",
          data: {
            pageSize: 10,
            pageNo: 1,
            typeId: "equipmentPosition",
          },
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.certificateAddress = []
              return
            }
            this.certificateAddress = res.content.list
            if (this.certificateData.length > 0) {
              this.certificateData.forEach((item) => {
                this.certificateAddress.forEach((it) => {
                  if (item.equipmentPosition == it.id) {
                    this.$set(item, "equipmentPosition0", it.dictName)
                  }
                })
              })
            }
          }
        })
    },
    // 获取设备信息
    getCertificate() {
      let params = {
        pageNo: 0,
        pageSize: -1,
      }
      this.$http
        .request({
          url: "/ypt/admin/communityEquipment/info/findList",
          method: "POST",
          data: params,
        })
        .then((res) => {
          if (res.code == 200) {
            if (res.content == null || res.content == "null") {
              this.tableData = []
              return
            }
            this.certificateList = res.content.list
          }
        })
    },
    // 获取选择设备的信息
    handleCertificate(val) {
      this.certificateList.forEach((item) => {
        if (val == item.id) {
          this.certificateForm.equipmentNumber = item.equipmentNumber
          this.certificateForm.equipmentName = item.equipmentName
          this.certificateForm.equipmentId = item.id
        }
      })
    },
    handlePosition(val) {
      this.certificateAddress.forEach((item) => {
        if (val == item.id) {
          this.certificateForm.equipmentPosition = item.id
          this.certificateForm.equipmentPosition0 = item.dictName
        }
      })
    },
    //自定义图片上传
    handleAvatarSuccess(res, file, name) {
      this.$set(this.addForm, "photo", res.content)
    },

    //新增项目保存
    save() {
      if (this.openData.title === "查看") {
        this.dialogVisibleClose()
        return
      }
      //  console.log()
      let url = ""
      if (this.openData.title === "编辑" || this.openData.title === "新增") {
        url =
          this.openData.title === "编辑"
            ? "/ypt/admin/pensionServicePoint/info/update"
            : "/ypt/admin/pensionServicePoint/info/insert"

        this.$refs["addForm"].validate((valid) => {
          if (valid) {
            let data = { ...this.addForm, ...this.exmainData }
            data.equipments = this.certificateData
            data.communityId = this.openData.communityId
            this.$http
              .request({
                url,
                method: "POST",
                data,
              })
              .then((res) => {
                if (res.code === 200) {
                  this.$message.success(res.message)
                  this.$emit("cancleOpen", true)
                } else {
                  this.$message.error(res.message)
                }
              })
          } else {
            console.log("error submit!!")
            return false
          }
        })
      } else if (this.openData.title === "审核") {
        url = "/ypt/admin/pensionServicePoint/info/review"
        this.$refs["exmains"].validate((valid) => {
          if (valid) {
            let data = { ...this.exmainData }
            data.communityId = this.openData.communityId
            data.id = this.addForm.id
            if (data.reviewStatus == "2" && data.auditOpinion == "") {
              this.$message.error("请填写不通过原因")
            } else {
              this.$http
                .request({
                  url,
                  method: "POST",
                  data,
                })
                .then((res) => {
                  if (res.code === 200) {
                    this.$message.success(res.message)
                    this.$emit("cancleOpen", true)
                  } else {
                    this.$message.error(res.message)
                  }
                })
            }
          } else {
            console.log("error submit!!")
            return false
          }
        })
      }
    },

    // 删除证书
    deleteCertificate(index) {
      console.log(index, "索引")
      this.certificateData.splice(index, 1)
    },
    // 弹窗关闭
    dialogVisibleClose() {
      this.certificateData = []
      this.certificate.pageSize = 10
      this.certificate.pageNo = 1
      this.certificate.total = 0
      this.formButtonType = "基本信息"
      this.$emit("cancleOpen", false)
    },
    // 切换展示类型
    changeButtonType(value) {
      console.log(this.addForm, "数据")
      this.formButtonType = value
    },
  },
}
</script>
<style lang="less" scoped>
.fromMain {
  display: flex;
  justify-content: space-around;
  margin-bottom: 25px;
}
/deep/ .el-upload1 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 100%;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 230px;
    line-height: 230px;
    text-align: center;
  }

  .avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 250px;
    line-height: 250px;

    img {
      width: 100%;
      height: 250px;
      line-height: 250px;
      display: block;
    }
  }
}
/deep/ .el-upload2 .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  width: 178px;
  height: 178px;
  line-height: 178px;
  cursor: pointer;
  position: relative;
  overflow: hidden;

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;

    img {
      width: 178px;
      height: 178px;
      line-height: 178px;
      display: block;
    }
  }
}
</style>
